import React, { FC } from "react";
import { ROUTES } from "src/constants/ROUTES";
import s from "./styles.module.sass";
import parse from "html-react-parser";
import clsx from "clsx";
import CustomLink from "../../../UI/CustomLink";
import { useStore } from "effector-react";
import { $isAuth } from "../../../../process/authProcess/model/public";

interface ICourseTypeCard {
	isFree?: boolean;
	description: string[];
	footnote?: string;
	isAuth: boolean;
}

const CourseTypeCard: FC<ICourseTypeCard> = ({ isFree, description, footnote, isAuth }) => {
	const linkText = "Поделиться знанием".toUpperCase();
	return (
		<div
			className={clsx(s.courseTypeCard, {
				[s.outlined]: isFree,
			})}
		>
			<div
				className={clsx(s.cardImage, {
					[s.free]: isFree,
				})}
			/>
			<h4>{isFree ? "Бесплатные курсы" : "Платные курсы"}</h4>
			<ul className={s.cardTextList}>
				{description.map((descr, index) => {
					return <li key={index}>{descr}</li>;
				})}
			</ul>
			<CustomLink
				href={isAuth ? ROUTES.INSTRUCTOR_PANEL_COURSES : ROUTES.LOGIN}
				text={linkText}
				size={"small"}
			/>
			{footnote && <p className={s.footnote}>{parse(footnote)}</p>}
		</div>
	);
};

const CreateCourses = () => {
	const isAuth = useStore($isAuth);

	return (
		<section className={`${s.createCourses} marginedSection`}>
			<h3 className={s.title}>Опубликовать бесплатно свой курс на обучающей платформе Selfschool</h3>
			<p className={s.description}>
				Удобный многофункциональный конструктор для создания и размещения обучающего контента
			</p>
			<div className={`${s.courseTypes}`}>
				<CourseTypeCard
					isAuth={isAuth}
					description={[
						"Доступ к полной функциональности конструктора (видеоуроки лекции, тесты квизы, ответы на вопросы студентов и т.д.);",
						"Неограниченная суммарная длительность онлайн-курса;",
						"Устанавливаемая вами стоимость курса (100₽ - 15 000₽)*;",
						"Бесплатная техподдержка.",
					]}
					footnote="*<b>60%</b> от стоимости курса получает Автор, <b>40%</b> — комиссия платформы Selfschool"
				/>
				<CourseTypeCard
					isAuth={isAuth}
					isFree
					description={[
						"Доступ к полной функциональности конструктора (видеоуроки лекции, тесты квизы, ответы на вопросы студентов и т.д.);",
						"Длительность онлайн-курса до 2 часов;",
						"Открытый некоммерческий курс для всех пользователей;",
						"Бесплатная техподдержка.",
					]}
				/>
			</div>
		</section>
	);
};

export default CreateCourses;
